import React, { useContext } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import PropTypes from 'prop-types';
import SocialLink from '../SocialLink';
import { HorizontalRule } from '../../common/HorizontalRule';
import { StyledWebView } from '../../common/StyledWebView';
import { H3 } from '../../text';
import LayoutContext from '../../../contexts/Layout';

const STYLED_WEB_VIEW_ID = 'cornerBlockWYSIWYG';

export const CornerblockWYSIWYG = ({
    backgroundColor,
    facebookLink,
    horizontalRuleColor,
    instagramLink,
    nodeTypeAlias = 'CornerBlockWYSIWYG',
    text,
    textColor,
    title,
    twitterLink,
    useHorizontalRule = true,
    width
}) => {
    const { layout } = useContext(LayoutContext);

    if (!text) {
        return null;
    }

    return (
        <View
            style={{ backgroundColor: backgroundColor, flex: 1, paddingVertical: layout.styleGuide.spacer2, paddingHorizontal: Math.floor(layout.styleGuide.indent * 3) }}
            dataSet={{
                umbracoComponentName: nodeTypeAlias,
                spacerBottom: `StyleGuide.spacer2(${layout.styleGuide.spacer2})`,
                spacerLeft: `StyleGuide.Indent*3(${Math.floor(layout.styleGuide.indent * 3)})`,
                spacerRight: `StyleGuide.Indent*3(${Math.floor(layout.styleGuide.indent * 3)})`,
                spacerTop: `StyleGuide.spacer2(${layout.styleGuide.spacer2})`
            }}
        >
            {!!title && (
                <View
                    style={{ alignItems: 'center', marginVertical: layout.styleGuide.spacer4 }}
                    dataSet={{ spacerBottom: `StyleGuide.Spacer4(${layout.styleGuide.spacer4})`, spacerTop: `StyleGuide.Spacer4(${layout.styleGuide.spacer4})` }}
                >
                    <H3 style={{ color: textColor }} text={title} />
                </View>
            )}

            {useHorizontalRule && <HorizontalRule color={horizontalRuleColor || '#ffffff'} />}

            <View style={{ marginBottom: layout.styleGuide.spacer3 }} dataSet={{ spacerBottom: `StyleGuide.Spacer3(${layout.styleGuide.spacer3})` }}>
                <StyledWebView html={text} nodeId={STYLED_WEB_VIEW_ID} textProps={{ style: { color: textColor || '#fff' } }} width={width * 0.5} />
            </View>

            <View style={Styles.socialLinksContainer}>
                {!!facebookLink?.externalUrl && (
                    <SocialLink
                        iconColor='#fff'
                        style={{ borderWidth: 0, paddingRight: layout.styleGuide.spacer2 }}
                        link={facebookLink.externalUrl}
                        type='facebook'
                        size={38}
                    />
                )}
                {!!instagramLink?.externalUrl && (
                    <SocialLink
                        iconColor='#fff'
                        style={{ borderWidth: 0, paddingRight: layout.styleGuide.spacer2 }}
                        link={instagramLink.externalUrl}
                        type='instagram'
                        size={38}
                    />
                )}
                {!!twitterLink?.externalUrl && (
                    <SocialLink iconColor='#fff' style={{ borderWidth: 0, paddingRight: layout.styleGuide.spacer2 }} link={twitterLink.externalUrl} type='twitter' size={38} />
                )}
            </View>
        </View>
    );
};

const Styles = StyleSheet.create({
    socialLinksContainer: {
        alignItems: 'center',
        backgroundColor: 'inherit',
        flexDirection: 'row',
        justifyContent: 'center',
        marginVertical: 0
    },
    title: {
        color: '#fff',
        fontFamily: 'GothamBook',
        fontSize: 24,
        letterSpacing: 0,
        lineHeight: 30,
        paddingTop: 20,
        paddingHorizontal: 10,
        paddingBottom: 20,
        marginTop: 10
    }
});

CornerblockWYSIWYG.propTypes = {
    facebookLink: PropTypes.object,
    horizontalRuleColor: PropTypes.string,
    instagramLink: PropTypes.object,
    text: PropTypes.string,
    title: PropTypes.string,
    twitterLink: PropTypes.object,
    useHorizontalRule: PropTypes.bool
};
